// Author SWL
// Date 2022-03-29 16:43:52

class EmArchToolChangeType {
constructor({
        id = null,
        type = '',
        remark = ''}
= {}) {
    this.id = id;
    this.type = type;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchToolChangeType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchToolChangeType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'type',
        label: 'label.em.archive.emArchToolChangeType.grid.type',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    typeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'typeFilter',
        label: 'label.em.archive.emArchToolChangeType.filter.type',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'type',
        label: 'label.em.archive.emArchToolChangeType.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmArchToolChangeType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
